/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueDatagridSizeRangeComponent } from './sysque-datagrid-size-range.component';
import { DxDataGridModule, DxSortableModule } from 'devextreme-angular';
import { SysqueSelectBoxModule } from '../sysque-select-box';

@NgModule({
  declarations: [SysqueDatagridSizeRangeComponent],
  imports: [CommonModule, DxDataGridModule, SysqueSelectBoxModule, DxSortableModule],
  exports: [SysqueDatagridSizeRangeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueDatagridSizeRangeModule {}
